// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V1C8h","label":"styles_label__3KIGP"};